import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import "./AdminPanel.css";

function ManagementManager() {
  const [managers, setManagers] = useState([]);
  const [formData, setFormData] = useState({ name: "", role: "", img_url: "" });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    const fetchManagers = async () => {
      const { data, error } = await supabase.from("management").select("*");
      if (error) {
        console.error("Yönetim bilgileri alınırken hata oluştu:", error);
      } else {
        setManagers(data);
      }
    };

    fetchManagers();
  }, []);

  const addManager = async () => {
    const { name, role, img_url } = formData;
  
    if (!name || !role) {
      alert("Tüm alanları doldurmanız gerekiyor.");
      return;
    }
  
    try {
      // Supabase'e yeni yönetici ekleme
      const { data, error } = await supabase
        .from("management")
        .insert([{ name, role, img_url }])
        .select(); // Eklenen veriyi döndürmek için 'select()' ekliyoruz.
  
      if (error) {
        console.error("Yönetici eklenirken hata oluştu:", error);
        alert("Yönetici eklenirken bir hata oluştu.");
        return;
      }
  
      if (data && data.length > 0) {
        // Veri döndüyse durumu güncelle
        setManagers([data[0], ...managers]);
        setFormData({ name: "", role: "", img_url: "" });
      }
    } catch (err) {
      console.error("Beklenmedik bir hata oluştu:", err);
      alert("Beklenmedik bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const updateManager = async () => {
    const { name, role, img_url } = formData;

    const { error } = await supabase
      .from("management")
      .update({ name, role, img_url })
      .eq("id", editingId);

    if (error) {
      console.error("Yönetici güncellenirken hata oluştu:", error);
    } else {
      setManagers(
        managers.map((manager) =>
          manager.id === editingId ? { id: editingId, name, role, img_url } : manager
        )
      );
      setEditingId(null);
      setFormData({ name: "", role: "", img_url: "" });
    }
  };

  const deleteManager = async (id) => {
    const confirmed = window.confirm("Bu yöneticiyi silmek istediğinize emin misiniz?");
    
    if (!confirmed) {
      return; // Kullanıcı iptal ederse hiçbir işlem yapma
    }
  
    try {
      const { error } = await supabase.from("management").delete().eq("id", id);
  
      if (error) {
        console.error("Yönetici silinirken hata oluştu:", error);
        alert("Yönetici silinirken bir hata oluştu.");
      } else {
        setManagers(managers.filter((manager) => manager.id !== id));
      }
    } catch (err) {
      console.error("Beklenmedik bir hata oluştu:", err);
      alert("Beklenmedik bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };
  

  return (
    <div className="admin-panel">
      <h1>Yönetim Düzenleme</h1>

      <div className="add-manager">
        <h3>Yeni Yönetici Ekle</h3>
        <input
          type="text"
          placeholder="Ad"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        <input
          type="text"
          placeholder="Görev"
          value={formData.role}
          onChange={(e) => setFormData({ ...formData, role: e.target.value })}
        />
        <input
          type="text"
          placeholder="Resim URL"
          value={formData.img_url}
          onChange={(e) => setFormData({ ...formData, img_url: e.target.value })}
        />
        <button onClick={editingId ? updateManager : addManager}>
          {editingId ? "Güncelle" : "Ekle"}
        </button>
      </div>

      <div className="manager-list">
        {managers.map((manager) => (
          <div key={manager.id} className="manager-item">
            <img src={manager.img_url} alt={manager.name} />
            <h3>{manager.name}</h3>
            <p>{manager.role}</p>
            <button
              onClick={() => {
                setEditingId(manager.id);
                setFormData({
                  name: manager.name,
                  role: manager.role,
                  img_url: manager.img_url,
                });
              }}
            >
              Düzenle
            </button>
            <button className="delete" onClick={() => deleteManager(manager.id)}>
              Sil
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ManagementManager;
